<template>
  <div class="values-root">
    <div class="values-header">
      <h2>Nossos Pilares</h2>
      <p>
        O que nos torna especialistas em Monitoramento e Avaliação não é apenas
        o que fazemos, mas como fazemos.
      </p>
    </div>

    <div class="values-grid">
      <article
        v-for="valor in coreValues"
        :key="valor.id"
        class="values-card"
        :class="valor.extraClass"
      >
        <div class="values-icon-wrapper">
          <span class="values-icon">{{ valor.icon }}</span>
        </div>
        <h3>{{ valor.title }}</h3>
        <p>{{ valor.description }}</p>
      </article>
    </div>

    <section class="values-highlight">
      <h3>Postura Dupla</h3>
      <p>
        "Realizamos atividades com excelência e, ao mesmo tempo, entendemos que
        também somos avaliados. Essa postura garante humildade e aprendizado
        constante."
      </p>

      <div class="values-tags">
        <span>✔ Humildade</span>
        <span>✔ Aprendizado</span>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CulturaValues',
  data() {
    return {
      coreValues: [
        {
          id: 'feedback',
          icon: '💬',
          title: 'Marca Registrada',
          description:
            'Feedback não é apenas uma tarefa, é nossa identidade. Damos retornos construtivos e recebemos como combustível para melhorar.',
          extraClass: 'values-card--blue',
        },
        {
          id: 'specialty',
          icon: '📊',
          title: 'Especialistas',
          description:
            'Monitoramento e avaliação são nossa especialidade. Fazemos com excelência porque entendemos o processo de ponta a ponta.',
          extraClass: 'values-card--cyan',
        },
        {
          id: 'humility',
          icon: '❤️',
          title: 'Postura Dupla',
          description:
            'Avaliamos, mas também somos avaliados. Essa consciência garante nossa humildade e nos mantém com os pés no chão.',
          extraClass: 'values-card--rose',
        },
        {
          id: 'learning',
          icon: '📚',
          title: 'Eternos Estudantes',
          description:
            'Nunca perdemos a capacidade de aprender o que não sabemos e de ensinar o que já dominamos.',
          extraClass: 'values-card--amber',
        },
      ],
    }
  },
}
</script>

<style scoped>
.values-root {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.values-header {
  text-align: center;
}

.values-header h2 {
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
}

.values-header p {
  margin-top: 8px;
  max-width: 540px;
  margin-left: auto;
  margin-right: auto;
  color: #64748b;
  font-size: 14px;
}

/* GRID */

.values-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.values-card {
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  padding: 16px 18px;
  background: #ffffff;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.02);
  transition: box-shadow 0.2s;
}

.values-card:hover {
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.07);
}

.values-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.values-icon {
  font-size: 22px;
}

.values-card h3 {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 6px;
}

.values-card p {
  font-size: 14px;
  color: #475569;
  line-height: 1.5;
}

/* CORES */

.values-card--blue {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.values-card--cyan {
  border-color: #bae6fd;
  background: #ecfeff;
}

.values-card--rose {
  border-color: #fecdd3;
  background: #fff1f2;
}

.values-card--amber {
  border-color: #fde68a;
  background: #fffbeb;
}

/* HIGHLIGHT */

.values-highlight {
  margin-top: 8px;
  text-align: center;
  border-radius: 16px;
  padding: 24px;
  background: #020617;
  color: #e5e7eb;
}

.values-highlight h3 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
}

.values-highlight p {
  max-width: 520px;
  margin: 0 auto 16px;
  font-size: 14px;
  color: #cbd5f5;
}

.values-tags {
  display: flex;
  justify-content: center;
  gap: 16px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 600;
}

.values-tags span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #bbf7d0;
}

/* Desktop */
@media (min-width: 768px) {
  .values-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
